module.exports = __webpack_public_path__ + "KaTeX_Math-BoldItalic.2ac376b5.woff2";